import React, { Component } from 'react'
import Home from './Home'

export default class Profile extends Component {
	state = {
		username: ''
	}

	componentDidMount() {
		this.getProfile()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.username != this.props.match.params.username) {
			this.getProfile()
		}
	}

	getProfile = () => {
		let { username } = this.props.match.params
		this.setState({ username })

		// axios.get(`/api/get_profile/${username}`)
		// .then(r => {
		// 	this.setState({username})
		// })
	}

	render() {
		let { username } = this.props.match.params
		return <>
			{username && <Home videos_url={`/api/get_videos/${username}`}/>}
		</>
	}
}
